import { NavLink } from 'react-router-dom'
import { CaretRight } from 'phosphor-react'

import { Medias } from '../../../../../../enumns/medias'
import { useMediaQuery } from '../../../../../../hooks/useMediaQuery'
import { Button } from '../../../../../../components/Button'
import { type ProjectDomain } from '../../../../../../types/domain/project-domain'
import clsx from 'clsx'

type ArchivedProjectItemProps = {
  archivedProject: ProjectDomain
  onUnarquiveProject: () => void
}

export const ArchivedProjectItem = ({
  archivedProject,
  onUnarquiveProject,
}: ArchivedProjectItemProps) => {
  const isMinScreenWidthLG = useMediaQuery(`(min-width: ${Medias.LG}px)`)

  return (
    <div className="flex items-center justify-between lg:bg-grey-100 rounded-[10px] lg:px-6 py-3 pr-4">
      <p className="text-sm font-medium  lg:font-normal lg:text-base text-grey-900">
        {archivedProject.id} - {archivedProject.name}
      </p>

      <div className="flex items-center gap-10">
        <Button
          type="button"
          variant="outline"
          onClick={onUnarquiveProject}
          className="py-2 lg:py-[11px] h-auto"
        >
          Desarquivar
        </Button>

        <NavLink to={`${archivedProject.id}`}>
          <CaretRight
            className={clsx({ 'text-2xl opacity-50': !isMinScreenWidthLG })}
          />
        </NavLink>
      </div>
    </div>
  )
}
